<template lang="pug">
.item.d-flex.flex-column.flex-md-row
  img.flex-shrink-0(:src="item.Image")
  .content.i_ml_6.i_ml_md_4.i_ml_sm_0
    h5.i_mr_8.i_mr_md_0 {{ item.Title }}
    p.i_body_l.i_mr_8.i_mr_md_0 {{ item.Brief }}
    .links.ul
      li
        router-link(
          tag="a",
          :to="{ name: 'ProductIntro', params: { type: item.Json } }"
        ) 商品介紹
      li
        router-link(
          tag="a",
          :to="{ name: 'ProductDescription', params: { type: item.Json } }"
        ) 詳細說明
      li
        router-link(
          tag="a",
          :to="{ name: 'ProductCliamSettlementIntro', params: { type: item.Json } }"
        ) 理賠資訊
      li(v-if="item.WebInsuredUrl && item.WebInsuredUrl != ''") 
        .insured_btn.btn_blue(@click="toUrl") 網路投保
</template>

<script>
export default {
  name: "ProductItem",
  props: {
    item: Object,
  },
  methods: {
    toUrl() {
      window.open(this.item.WebInsuredUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-radius: 17px;
  box-shadow: 1px 2px 3px 0 rgba(216, 216, 216, 0.25);
  border: solid 1px #cacccf;
  background-color: #ffffff;
  padding: 30px 40px;
}

img {
  @include size(255px, 194px);
}

h5 {
  @include font(22px, $color_black_text, 500);
}

p {
  font-weight: normal;
}

.links {
  float: right;
  font-size: 14px;

  li {
    margin-left: 20px;
    display: inline-block;
  }

  a {
    color: $color_black_inactive;
    text-decoration: underline;
    cursor: pointer;
  }

  .insured_btn.btn_blue {
    color: white;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
  }
}

@media (max-width: 991px) {
  .item {
    padding-left: 30px;
    padding-right: 30px;
  }

  img {
    @include size(204px, 178px);
  }

  h5 {
    font-size: 16px;
  }

  .links {
    li {
      margin-left: 10px;
    }
  }
}

@media (max-width: 767px) {
  img {
    @include size(100%, 39vw);
  }

  h5 {
    margin-top: 30px;
    font-size: 24px;
  }

  .links {
    li {
      font-size: 20px;
    }

    .insured_btn.btn_blue {
      color: white;
      height: 39px;
      line-height: 39px;
      border-radius: 19px;
      padding-left: 20px;
      padding-right: 20px;
      cursor: pointer;
    }
  }
}

@media (max-width: 575px) {
  .item {
    padding: 5.2vw;
  }

  h5 {
    margin-top: 5.2vw;
    font-size: 4.2vw;
  }

  p {
    font-size: 3.5vw;
  }

  .links {
    li {
      font-size: 3.5vw;
      margin-left: 2.6vw;
    }

    li:first-child {
      margin-left: 0;
    }

    .insured_btn.btn_blue {
      height: 6.7vw;
      line-height: 6.7vw;
      border-radius: 3.29vw;
      padding-left: 3vw;
      padding-right: 3vw;
    }
  }
}
</style>
